import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { ArrowLeftShort, ArrowRightShort } from 'react-bootstrap-icons';

import useDraggableScroll from '../../hooks/use_draggable_scroll';

const Slider = ({ children, full_width = false }) => {
	const ref = useRef(null);
	const scrollThreshold = 10;
	const scrollWidth = 0.7;

	const [showLeftButton, setShowLeftButton] = useState(true);
	const [showRightButton, setShowRightButton] = useState(true);

	const { onMouseDown } = useDraggableScroll(ref, { direction: 'horizontal' });

	const handleScroll = () => {
		const container = ref.current;
		const containerWidth = container.clientWidth;

		if (container.scrollLeft <= scrollThreshold) {
			setShowLeftButton(false);
		} else {
			setShowLeftButton(true);
		}

		if (
			container.scrollWidth - containerWidth - container.scrollLeft <=
			scrollThreshold
		) {
			setShowRightButton(false);
		} else {
			setShowRightButton(true);
		}
	};

	useEffect(() => {
		const container = ref.current;
		container.addEventListener('scroll', handleScroll);
		handleScroll(); // Initial check

		return () => {
			container.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return (
		<section className="slider">
			{showLeftButton && (
				<div
					className={`slider-btn-container ${
						full_width === true ? 'slider-btn-container-fullwidth' : ''
					}`}
				>
					<button
						className="btn text-white btn-circle btn-circle-lg btn-dark slider-btn-left"
						onClick={() => {
							const container = ref.current;
							const containerWidth = container.clientWidth;
							container.scrollLeft -= containerWidth * scrollWidth;
						}}
					>
						<ArrowLeftShort />
					</button>
					<span className="slider-fade slider-fade-left" />
				</div>
			)}

			<div
				className={`slider-container ${
					full_width && 'slider-container-fullwidth'
				}`}
				onMouseDown={onMouseDown}
				ref={ref}
			>
				{children}
			</div>

			{showRightButton && (
				<div
					className={`slider-btn-container ${
						full_width === true ? 'slider-btn-container-fullwidth' : ''
					}`}
				>
					<button
						className="slider-btn-right btn text-white btn-circle btn-circle-lg btn-dark"
						onClick={() => {
							const container = ref.current;
							const containerWidth = container.clientWidth;
							container.scrollLeft += containerWidth * scrollWidth;
						}}
					>
						<ArrowRightShort />
					</button>
					<span className="slider-fade slider-fade-right" />
				</div>
			)}
		</section>
	);
};

Slider.propTypes = {
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	full_width: PropTypes.bool,
};

export default Slider;
